import { RefObject } from "react";

/**
 * Marks an element that explains a blocked submit but is not a form field,
 * such as a rule that spans several fields. Spread onto the element.
 */
export const SUBMIT_ERROR_PROPS = {
	"data-submit-error": "",
	"tabIndex": -1,
} as const;

const isFocusTarget = (element: HTMLElement) =>
	element.hasAttribute("data-submit-error") ||
	(element.tabIndex >= 0 && element.getClientRects().length > 0);

/**
 * Focuses the first invalid control in `scope`, in document order, or the
 * first element marked with `SUBMIT_ERROR_PROPS`. The library's selects
 * register a hidden input, so react-hook-form's own `setFocus` cannot reach them.
 */
export const focusFirstError = (scope: ParentNode | null | undefined) => {
	const candidates =
		scope?.querySelectorAll<HTMLElement>(
			'[aria-invalid="true"], [data-submit-error]'
		) ?? [];

	Array.from(candidates).find(isFocusTarget)?.focus();
};

/**
 * `focusFirstError` for validation run outside a submit, such as a debt card's
 * Save. It waits two frames, so a section opened by the same press has rendered.
 */
export const focusFirstErrorAfterRender = (
	scope: RefObject<HTMLElement | null>
) =>
	requestAnimationFrame(() =>
		requestAnimationFrame(() => focusFirstError(scope.current))
	);
